import { get } from "../ajax";

export async function collectionRecord(body: Record<string, any> ){
    const url = `/api/CollectRecord/GetCollectRecordPageList?Mobile=${body.Mobile}&ActivityName=${body.ActivityName}&ProductName=${body.ProductName}&PageIndex=${body.PageIndex}&PageSize=${body.PageSize}`
    const res = await get(url)
    return res;
}

export async function collectionRecordDetail(id:string){
    const url = `/api/CollectRecord/GetCollectRecordDetail?id=${id}`
    const res = await get(url)
    return res;
}